import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_goToMachine } from './taskGoToMachine'
import { monsters } from '../monsters/monsters-sidecar'
import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'

export function createTask_takeOffSuit(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'take-off-suit', {})
}

export function runTask_takeOffSuit(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'take-off-suit')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (!m.isInSuit) {
    return jobLogger.succeedTask(job, task)
  }

  let f = (c: IMachine) => c.data.type === 'suits'
  let mc = machines.findAtSpot(m.i, m.j, f)
  if (mc) {
    // Here!
    mc.hasSuit = true
    monsters.setInSuit(m, false)
    return jobLogger.succeedTask(job, task)
  }

  task.subtasks.push(createTask_goToMachine(m.i, m.j, f))
  return
  // // Are we finding a path?
  // if (job.findPathId) {
  //   return // Wait for this to complete
  // }

  // // Are we moving?
  // if (m.path.length > 0) {
  //   return // Wait for this to complete
  // }
  // let f = (c: IMachine) => c.data.type === 'suits'

  // if (machines.findAtSpot(m.i, m.j, f)) {
  //   // Here!
  //   task.isComplete = true

  //   return
  // }

  // let mc = machines.findClosestTo(m.i, m.j, f)
  // if (!mc) {
  //   return jobLogger.failTask(job, task, 'lost machine')
  // }

  // // Find path to delivery spot!
  // job.findPathId = pathFinder.findPath(
  //   m.i,
  //   m.j,
  //   mc.i,
  //   mc.j,
  //   m.isInsideShip,
  //   (path) => {
  //     job.findPathId = 0
  //     if (!task) {
  //       throw new Error('lost our task!')
  //     }

  //     if (!path || path.length === 0) {
  //       return jobLogger.failTask(job, task, 'no path')
  //     } else {
  //       if (m) {
  //         monsters.setPath(m, path)
  //       }
  //     }
  //   },
  // )
}
